var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMirror(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3467_9793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.279297 9.44569C0.279297 4.33691 4.42712 0.1875 9.53749 0.1875H28.0524C33.1627 0.1875 37.3106 4.33533 37.3106 9.44569V27.9606C37.3106 33.0709 33.1627 37.2188 28.0524 37.2188H9.53749C4.42712 37.2188 0.279297 33.0709 0.279297 27.9606V9.44569Z",
    fill: "#FFDD33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8947 7.25195H21.5354L24.3375 12.1739L18.176 7.25195H14.8165L17.8973 13.2631L11.4571 7.25195H8.09766L11.4571 14.9096L8.09766 30.2233H11.4571L17.8973 13.8188L14.8165 30.2233H18.176L24.3375 12.7217L21.5354 30.2233H24.8947L31.0564 11.0847L24.8947 7.25987V7.25195Z",
    fill: "#1C1C1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3467_9793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.5,
    height: 37.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirror);
export default __webpack_public_path__ + "static/media/mirror.275de7f8b97b15887d36dc17966fd872.svg";
export { ForwardRef as ReactComponent };